module.exports = __webpack_public_path__ + "static/img/home-pub-pr.557b4f92.jpg";